import { render, staticRenderFns } from "./EditPaket.vue?vue&type=template&id=482c89a2&scoped=true"
import script from "./EditPaket.vue?vue&type=script&lang=js"
export * from "./EditPaket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482c89a2",
  null
  
)

export default component.exports